import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal", "body"]

    connect() {
        this.handleEscape = this.handleEscape.bind(this)
        document.addEventListener('keydown', this.handleEscape)
    }

    disconnect() {
        document.removeEventListener('keydown', this.handleEscape)
    }

    open() {
        if (this.hasModalTarget) {
            this.modalTarget.classList.remove('hidden')
            document.body.classList.add('overflow-hidden')
            if (this.hasBodyTarget) {
                setTimeout(() => this.bodyTarget.focus(), 100)
            }
        }
    }

    close() {
        if (this.hasModalTarget) {
            this.modalTarget.classList.add('hidden')
            document.body.classList.remove('overflow-hidden')
            if (this.hasBodyTarget) {
                this.bodyTarget.value = ''
            }
        }
    }

    handleEscape(event) {
        if (event.key === 'Escape') {
            this.close()
        }
    }

    onSubmitEnd(event) {
        if (event.detail.success) {
            setTimeout(() => this.close(), 2000)
        }
    }
}
